import { Action } from '../actions/membership';

export const defaultState = {
  dynamicPricingError: undefined,
  hasDynamicPricing: false,
  isFetchingLoyalty: false,
  isFetchingOffers: false,
  isFetchingWallet: false,
  loyalty: undefined,
  loyaltyError: undefined,
  offersError: undefined,
  premium: undefined,
  wallet: undefined,
  walletError: undefined,
};

export default function membershipReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case Action.Pay.FetchLoyalty:
      return {
        ...state,
        isFetchingLoyalty: true,
        loyaltyError: undefined,
      };

    case Action.Pay.FetchLoyaltyCompleted:
      return {
        ...state,
        isFetchingLoyalty: false,
        loyalty: action.payload.loyalty,
        loyaltyError: undefined,
      };

    case Action.Pay.FetchLoyaltyFailed:
      return {
        ...state,
        isFetchingLoyalty: false,
        loyaltyError: action.payload,
      };

    case Action.Pay.FetchWallet:
      return {
        ...state,
        isFetchingWallet: true,
        walletError: undefined,
      };

    case Action.Pay.FetchWalletCompleted:
      return {
        ...state,
        isFetchingWallet: false,
        wallet: action.payload.wallet,
        walletError: undefined,
      };

    case Action.Pay.FetchWalletFailed:
      return {
        ...state,
        isFetchingWallet: false,
        walletError: action.payload,
      };

    case Action.Pay.FetchOffers:
      return {
        ...state,
        isFetchingOffers: true,
        offersError: undefined,
      };

    case Action.Pay.FetchOffersCompleted:
      return {
        ...state,
        isFetchingOffers: false,
        premium: action.payload.premium,
        offersError: undefined,
      };

    case Action.Pay.FetchOffersFailed:
      return {
        ...state,
        isFetchingOffers: false,
        offersError: action.payload,
      };

    default:
      return state;
  }
}
